// extracted by mini-css-extract-plugin
export default {"light":"light__3N0yy"};